import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "../src/Pages/LandingPage/LandingPage.jsx";
import Header from "./components/Header/Header.jsx";
import ReachOutPage from "./Pages/Reactout/ReachOut.jsx";

function App() {
  const handleSignOut = () => {
    console.log("Signing out...");
  };

  return (
    <Router>
      <Header onSignOut={handleSignOut} />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/reachout" element={<ReachOutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
